import { __assign } from "tslib";
import React from 'react';
import Alborz from './Alborz';
import Ardabil from './Ardabil';
import Bushehr from './Bushehr';
import Fars from './Fars';
import Gilan from './Gilan';
import Golestan from './Golestan';
import Hamadan from './Hamadan';
import Hormozgan from './Hormozgan';
import Ilam from './Ilam';
import Isfahan from './Isfahan';
import Kerman from './Kerman';
import Kermanshah from './Kermanshah';
import Khuzestan from './Khuzestan';
import Kurdistan from './Kurdistan';
import Lorestan from './Lorestan';
import Markazi from './Markazi';
import Mazandaran from './Mazandaran';
import NorthKhorasan from './NorthKhorasan';
import Qazvin from './Qazvin';
import Qom from './Qom';
import RazaviKhorasan from './RazaviKhorasan';
import Semnan from './Semnan';
import SouthKhorasan from './SouthKhorasan';
import Tehran from './Tehran';
import WestAzerbaijan from './WestAzerbaijan';
import Yazd from './Yazd';
import Zanjan from './Zanjan';
import ChaharmahalandBakhtiari from './ChaharmahalandBakhtiari';
import EastAzerbaijan from './EastAzerbaijan';
import KohgiluyehAndBoyerAhmad from './KohgiluyehAndBoyerAhmad';
import SistanAndBaluchestan from './SistanAndBaluchestan';
var Province = function (_a) {
    var _b;
    var province = _a.province, mapRef = _a.mapRef, pathClickedHandle = _a.pathClickedHandle, pathMouseOverHandler = _a.pathMouseOverHandler, width = _a.width, textColor = _a.textColor;
    var provinceProps = { mapRef: mapRef, pathClickedHandle: pathClickedHandle, pathMouseOverHandler: pathMouseOverHandler, width: width, textColor: textColor };
    var provincesList = [
        {
            name: 'alborz',
            component: React.createElement(Alborz, __assign({}, provinceProps)),
        },
        {
            name: 'ardabil',
            component: React.createElement(Ardabil, __assign({}, provinceProps)),
        },
        {
            name: 'bushehr',
            component: React.createElement(Bushehr, __assign({}, provinceProps)),
        },
        {
            name: 'chaharmahalandBakhtiari',
            component: React.createElement(ChaharmahalandBakhtiari, __assign({}, provinceProps)),
        },
        {
            name: 'eastAzerbaijan',
            component: React.createElement(EastAzerbaijan, __assign({}, provinceProps)),
        },
        {
            name: 'fars',
            component: React.createElement(Fars, __assign({}, provinceProps)),
        },
        {
            name: 'gilan',
            component: React.createElement(Gilan, __assign({}, provinceProps)),
        },
        {
            name: 'golestan',
            component: React.createElement(Golestan, __assign({}, provinceProps)),
        },
        {
            name: 'hamadan',
            component: React.createElement(Hamadan, __assign({}, provinceProps)),
        },
        {
            name: 'hormozgan',
            component: React.createElement(Hormozgan, __assign({}, provinceProps)),
        },
        {
            name: 'ilam',
            component: React.createElement(Ilam, __assign({}, provinceProps)),
        },
        {
            name: 'isfahan',
            component: React.createElement(Isfahan, __assign({}, provinceProps)),
        },
        {
            name: 'kerman',
            component: React.createElement(Kerman, __assign({}, provinceProps)),
        },
        {
            name: 'kermanshah',
            component: React.createElement(Kermanshah, __assign({}, provinceProps)),
        },
        {
            name: 'khuzestan',
            component: React.createElement(Khuzestan, __assign({}, provinceProps)),
        },
        {
            name: 'kohgiluyehAndBoyerAhmad',
            component: React.createElement(KohgiluyehAndBoyerAhmad, __assign({}, provinceProps)),
        },
        {
            name: 'kurdistan',
            component: React.createElement(Kurdistan, __assign({}, provinceProps)),
        },
        {
            name: 'lorestan',
            component: React.createElement(Lorestan, __assign({}, provinceProps)),
        },
        {
            name: 'markazi',
            component: React.createElement(Markazi, __assign({}, provinceProps)),
        },
        {
            name: 'mazandaran',
            component: React.createElement(Mazandaran, __assign({}, provinceProps)),
        },
        {
            name: 'northKhorasan',
            component: React.createElement(NorthKhorasan, __assign({}, provinceProps)),
        },
        {
            name: 'qazvin',
            component: React.createElement(Qazvin, __assign({}, provinceProps)),
        },
        {
            name: 'qom',
            component: React.createElement(Qom, __assign({}, provinceProps)),
        },
        {
            name: 'razaviKhorasan',
            component: React.createElement(RazaviKhorasan, __assign({}, provinceProps)),
        },
        {
            name: 'semnan',
            component: React.createElement(Semnan, __assign({}, provinceProps)),
        },
        {
            name: 'sistanAndBaluchestan',
            component: React.createElement(SistanAndBaluchestan, __assign({}, provinceProps)),
        },
        {
            name: 'southKhorasan',
            component: React.createElement(SouthKhorasan, __assign({}, provinceProps)),
        },
        {
            name: 'tehran',
            component: React.createElement(Tehran, __assign({}, provinceProps)),
        },
        {
            name: 'westAzerbaijan',
            component: React.createElement(WestAzerbaijan, __assign({}, provinceProps)),
        },
        {
            name: 'yazd',
            component: React.createElement(Yazd, __assign({}, provinceProps)),
        },
        {
            name: 'zanjan',
            component: React.createElement(Zanjan, __assign({}, provinceProps)),
        },
    ];
    return React.createElement(React.Fragment, null, (_b = provincesList.find(function (pr) { return pr.name === province; })) === null || _b === void 0 ? void 0 : _b.component);
};
export default Province;
//# sourceMappingURL=index.js.map